// Palette
import palette from '../palette'

export default {
  root: {
    height: '56px',
    '&$selected': {
      backgroundColor: palette.background.light,
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.background.light,
      },
    },
  },
}
